import { render, staticRenderFns } from "./MsgAnalysisVoice.vue?vue&type=template&id=4a1722c5&"
import script from "./MsgAnalysisVoice.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysisVoice.vue?vue&type=script&lang=js&"
import style0 from "./MsgAnalysisVoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports